if (!customElements.get('size-indicator')) {
    customElements.define(
        'size-indicator',
        class ComponentSizeIndicator extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback() {
                this.onVariantChangeUnsubscriber = subscribe(
                    PUB_SUB_EVENTS.variantChange,
                    this.handleOptionValueChange.bind(this)
                );
            }
            handleOptionValueChange(data) {
                let options = data.data.variant.options;

                var opt = Array.from(new Set(options));
                for (let i = 0; i < opt.length; i++) {
                    opt[i] = opt[i].trim().toUpperCase();
                    opt[i] += opt[i] === "S" ? " ( 60 x 40 cm )" : opt[i] === "M" ? " ( 80 x 60 cm )" :opt[i] === "L" ? " ( 100 x 70 cm )" : "";
                }
                this.querySelector('span').innerText = opt.join(' - ')
            }
        });

}